export default __webpack_public_path__ + "static/media/Logout.7ac28951.svg";